var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zzz-icon"},[_c('img',{attrs:{"src":require("../../assets/zzz.svg")}}),_c('q-tooltip',{attrs:{"delay":400}},[_vm._v("Device is in standby due to its schedule")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }